import moment from "moment";

export default (state = false, action) => {
  switch (action.type) {
    case "SET_CAN_ADD_OCCUPANCY":
      const currentOccupancies = action.payload.occupancies.filter((occ) => {
        return (
          occ.moved_in_at && moment(occ.moved_in_at).isBefore() && !occ.moved_out_at ||
          occ.moved_in_at && moment(occ.moved_in_at).isBefore() &&
          occ.moved_out_at && moment(occ.moved_out_at).isAfter()
        );
      });

      const canAddOccupancy = action.payload.organization['recovery_coaching?'] ||
                              action.payload.organization['treatment_center?'] ||
                              action.payload.organization['drug_court_program?'] ||
                              action.payload.organization['sober_home?'] && currentOccupancies.length == 0
      return canAddOccupancy;
    default:
      return state;
  }
}
